<template>
  <!-- 动态详情 -->
  <div class="page-dynamic-detail" :class="{'mobile':$vuetify.breakpoint.mobile, 'pc': !$vuetify.breakpoint.mobile}">
    <div class="page-dynamic-detail-warp g-container g-wrap pb-md-12" :class="{'mobile':$vuetify.breakpoint.mobile, 'pc': !$vuetify.breakpoint.mobile}">
      <div class="g-article-wrap pt-4 pt-md-10 px-4 px-md-0">
        <div class="header">
          <h1>{{detailData.title}}</h1>
          <p class="time mt-2 mt-md-5">
            {{detailData.publistTime | DateFormat('yyyy-MM-dd')}}

            <span class="source">来源：{{detailData.resources}}</span>
          </p>
          <div class="line mt-5" v-if="!$vuetify.breakpoint.mobile">
            <img src="@images/line.png" alt="">
          </div>
        </div>

        <div class="con">
          <!-- <div class="video-box mt-4 mt-md-6" v-if="detailData.fileUrl">
            <video id="myVideo"
              ref="video"
              class="video-js vjs-default-skin"
              controls
            >
              <source :src="detailData.fileUrl" />
            </video>
          </div> -->

          <div class="g-detail-html trans my-5" v-html="detailData.content"></div>
        </div>

        <div class="bottom" v-if="detailData.outLinkUrl">
          <span class="name">原文链接：</span>
          <p class="link" @click="goOut">吉林省博物院微信订阅号和微博账号被评选为“最具传播力奖”</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import '@css/mobile/dynamic/detail.scss';
  export default {
    data() {
      return {
        defaultHeadImg: this.$store.state.app.defaultHeadImg,
        detailId: this.$route.query.id,
        detailData: {}
      }
    },
    methods: {
      getDetailData() {
        this.$http
          .get('/common/articleDetail', {
            id: this.detailId,
            category: this.$route.query.category
          })
          .then(res => {
            if (res.success) {
              this.detailData = res.data

              // this.$nextTick(() => {
              //   this.initVideo()
              // })
            } else {
              this.$notify(res.message)
            }
          })
      },
      goOut() {
        window.open(this.detailData.outLinkUrl)
      },
      initVideo() {
        //初始化视频方法
        let myPlayer = this.$video(myVideo, {
          controls: true,
          // autoplay: "muted",
          preload: "auto",
          poster: this.detailData.showPicUrl,
          // width: "800px",
          // height: "400px"
        });
      },
    },
    created() {
      this.getDetailData()
    }
  }
</script>

<style lang="scss" scoped>
.page-dynamic-detail-warp {
  .video-box {
    .video-js {
      margin: 0 auto;
      width: 600px;
      height: 400px;
    }
  }

  .source {
    margin-left: 20px;
  }
  .bottom {
    display: flex;
    align-items: baseline;
    font-size: 14px;
    color: #999;
    margin-bottom: 20px;
    .name {
      
    }
    .link {
      color: #1890FF;
      cursor: pointer;
    }
  }

  &.mobile {
    .bottom {
      .name {
        width: 110px;
      }
    }
  }
}
</style>